import React, { useRef, useEffect, useState } from "react";
import { Link } from "gatsby";
import linkResolver from "../../../../linkResolver";

export default function SectionCarter({ slice, location }) {
  const containerRef = useRef(null);
  const [showGradient, setShowGradient] = useState(false);

  useEffect(() => {
    const checkScrollable = () => {
      const container = containerRef.current;
      if (container) {
        setShowGradient(container.scrollWidth > container.clientWidth);
      }
    };

    // Check initially with a small delay to ensure rendering is complete
    const timer = setTimeout(checkScrollable, 100);

    // Check on window resize
    window.addEventListener("resize", checkScrollable);

    return () => {
      clearTimeout(timer);
      window.removeEventListener("resize", checkScrollable);
    };
  }, [slice.items]);

  return (
    <div className={`${location?.pathname === "/blog/" ? "" : "bg-[#F2F3F5]"}`}>
      <div
        className={`${location?.pathname === "/blog/" ? "" : "px-6 xl:px-16"} max-w-7xl mx-auto py-10`}
      >
        {/* Section Header */}
        <div>
          <h2 className="font-manrope text-2.5xl md:text-3.25xl font-medium text-purple-1100 mb-4">
            {slice.primary.title?.text || "Explore featured series"}
          </h2>
          <p className="font-inter text-sm md:text-lg text-gray-2500 max-w-2xl mb-10">
            {slice.primary.descriptor_text?.text || "Lorem ipsum description"}
          </p>
        </div>

        {/* Cards Container with Gradient Overlay */}
        <div className="relative">
          <div
            ref={containerRef}
            className="flex gap-4 overflow-x-auto rounded-lg"
            style={{
              scrollbarWidth: "none",
              msOverflowStyle: "none",
            }}
          >
            {slice.items.map((item, index) => (
              <div
                key={index}
                className="group cursor-pointer flex-shrink-0 max-w-[78vw] max-h-[493px]"
              >
                <Link
                  to={
                    item.internal_link
                      ? linkResolver(item.internal_link) ||
                        `/${item.internal_link.uid}`
                      : "#"
                  }
                  className="block h-full"
                >
                  <div className="relative rounded-lg overflow-hidden h-[400px] lg:h-[493px]">
                    {/* Background Image */}
                    <img
                      src={item.card_image?.url}
                      alt={
                        item.card_image?.alt ||
                        item.card_title?.text ||
                        "Card image"
                      }
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                      loading="lazy"
                    />
                    {/* Gradient Overlay - Dark at bottom */}
                    <div
                      className="absolute inset-0 opacity-80"
                      style={{
                        background:
                          "linear-gradient(0deg, #0F0624 0%, transparent 100%)",
                      }}
                    />
                    {/* Content Overlay */}
                    <div className="absolute bottom-0 left-0 right-0 px-3 md:px-5 text-white py-6">
                      {/* "New" Badge */}
                      {item.has_new_episode && (
                        <p className="bg-[#C5BBFF] text-[#0F0624] px-3 py-1 mb-3 rounded-full text-xs md:text-sm font-medium inline-block">
                          New
                        </p>
                      )}
                      <h3 className="font-manrope text-2xl md:text-2xl lg:text-2.5xl font-medium mb-3">
                        {item.card_title?.text}
                      </h3>
                      <p className="font-inter text-sm md:text-base text-white text-opacity-90 mb-3 md:mb-6 line-clamp-3">
                        {item.card_description?.text}
                      </p>
                      {item.total_episode_count.text && (
                        <p className="font-inter text-sm text-white text-opacity-70">
                          {item.total_episode_count.text} Episodes
                        </p>
                      )}
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>

          {/* Right Gradient Overlay for Scroll Indication */}
          {showGradient && (
            <div
              className="absolute top-0 right-0 w-8 h-full pointer-events-none z-10"
              style={{
                background:
                  "linear-gradient(270deg, #F2F3F5 0%, rgba(242, 243, 245, 0.2) 60%, transparent 100%)",
              }}
            />
          )}
        </div>

        {/* Hide scrollbar */}
        <style jsx>{`
          .flex::-webkit-scrollbar {
            display: none;
          }
        `}</style>
      </div>
    </div>
  );
}
